import React, { useState, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import "../login/login.css";
import LoadingOverlay from "react-loading-overlay";
import useFormValidation from '../../hooks/useFormValidator';
import axios from "../../axios/axios";
import { message } from "antd";
const VipSignup = () => {
    const [showLoader, setShowLoader] = useState(false);
    const [input, setInput] = useState({
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        phone: "",
        careFiCode: ""
    });
    const [errors, setErrors] = useState({});
    const [checkBox, setCheckbox] = useState(false);
    const [validationReport, validate] = useFormValidation();
    const validationRules = {
        email: { required: true, email: true },
        password: { required: true, password: true },
        firstName: { required: true },
        lastName: { required: true },
        phone: { required: true },
        careFiCode: { required: true },
    };

    const validateField = (name, value) => {
        const rules = validationRules[name];
        let error = "";

        if (!rules) return "";

        if (rules.required && !value.trim()) {
            error = "This field is required";
        } else if (rules.email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) error = "Invalid email address";
        } else if (rules.password) {
            var regularExpression =
                /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
            if (!regularExpression.test(value) && value.length < 8) {
                error = "Minimum 1 uppercase,1 number,1 special character and 8 letters long";
            }
        }

        return error;
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setInput((prev) => ({ ...prev, [name]: value }));

        const error = validateField(name, value);
        setErrors((prev) => ({ ...prev, [name]: error }));
    };
    const handleCheckboxChange = () => {
        setCheckbox(!checkBox);
    };

    const handelSubmit = async () => {
        console.log(input, "input", validationRules)
        let formErrors = {};
        let isValid = true;

        Object.keys(validationRules).forEach((field) => {
            const error = validateField(field, input[field]);
            if (error) {
                isValid = false;
                formErrors[field] = error;
            }
        });

        setErrors(formErrors);

        if (!isValid) {
            message.error("Please fill all the required fields");
            return;
        }

        if (!checkBox) {
            message.error("Please check this box if you want to proceed");
            return;
        }

        try {
            setShowLoader(true);
            let dataSet = {
                ...input,
                affiliate: "",
                address: "",
                city: "",
                country: "",
                state: "",
                zipCode: "",
                source: "tvi",
                isVipEscapeBuckUser: true,
                ipAddress: (localStorage.getItem('clientIp')) ? localStorage.getItem('clientIp') : '',
                user_type: "individual"
            }
            const response = await axios.post(
                "/user/create-vip-escape-bucks-user",
                dataSet
            );
            console.log("response", response);
            if (response.data.status) {
                message.success(
                    "You are successfully registered. Please wait for automatically login."
                );
                setTimeout(() => {
                    window.location.href = response.data.data.dashboardURL;
                }, 2000);
            } else {
                message.error(response.data.message);
            }
        } catch (error) {
            message.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setShowLoader(false);
        }
    };
    return (
        <div>
            <LoadingOverlay
                active={showLoader}
                className="loading_overlay text-dark"
                //spinner= <img src={Logo} />
                text=""
            >
                <div className="main_cont">
                    <div className="login_page">

                        <div className="login_page_left"></div>

                        <div className="login_page_right">

                            <div className="login_inner_bottom text-white">

                                <div className="new_user text-center">
                                    <h3 className="signup_link">Create Your Account</h3>
                                    <small>*All fields are mandatory</small>
                                </div>

                                <Form>
                                    <Form.Group className="mb-4" controlId="formBasicEmail">
                                        <Form.Label>Email address</Form.Label>
                                        <Form.Control
                                            type="email"
                                            className="login_field"
                                            data-rules={JSON.stringify({
                                                required: true,
                                                email: true,
                                            })}
                                            onChange={(event) => {
                                                handleChange(event);
                                            }}
                                            name="email"
                                            value={input.email}
                                        //value={user.email}
                                        />
                                        {errors.email && (
                                            <small className="text-danger">
                                                {errors.email}
                                            </small>
                                        )}
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>Create Your Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            className="login_field"
                                            data-rules={JSON.stringify({
                                                required: true,
                                                password: true,
                                            })}
                                            onChange={(event) => {
                                                handleChange(event);
                                            }}
                                            name="password"
                                            value={input.password}
                                        />
                                        {errors.password && (
                                            <small className="text-danger">
                                                {errors.password}
                                            </small>
                                        )}
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="firstName"
                                            placeholder="Enter First Name"
                                            data-rules={JSON.stringify({
                                                required: true
                                            })}
                                            onChange={(event) => { handleChange(event) }}
                                            className="login_field"
                                            value={input.firstName}
                                        />
                                        {errors.firstName && (
                                            <small className="text-danger">
                                                {errors.firstName}
                                            </small>
                                        )}
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            className="login_field"
                                            name="lastName"
                                            data-rules={JSON.stringify({
                                                required: true
                                            })}
                                            onChange={(event) => {
                                                handleChange(event)
                                            }}
                                            value={input.lastName}
                                        //value={user.password}
                                        />
                                        {errors.lastName && (
                                            <small className="text-danger">
                                                {errors.lastName}
                                            </small>
                                        )}
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>Phone Number</Form.Label>
                                        <Form.Control
                                            type="tel"
                                            className="login_field"
                                            name="phone"
                                            value={input.phone}
                                            data-rules={JSON.stringify({
                                                required: true
                                            })}
                                            onChange={(event) => { handleChange(event) }}
                                        //value={user.password}
                                        />
                                        {errors.phone && (
                                            <small className="text-danger">
                                                {errors.phone}
                                            </small>
                                        )}
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                        <Form.Label>Redemption Code</Form.Label>
                                        <Form.Control
                                            type="text"
                                            className="login_field"
                                            name="careFiCode"
                                            value={input.careFiCode}
                                            data-rules={JSON.stringify({
                                                required: true
                                            })}
                                            onChange={(event) => { handleChange(event) }}

                                        //value={user.password}
                                        />
                                        {errors.careFiCode && (
                                            <small className="text-danger">
                                                {errors.careFiCode}
                                            </small>
                                        )}
                                    </Form.Group>


                                    <div className="login_submit d-flex justify-content-between align-items-center">
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                id="customCheck1"
                                                checked={checkBox}
                                                onChange={handleCheckboxChange}
                                            />
                                            <label className="custom-control-label" htmlFor="customCheck1">
                                                I agree to the <a href="https://tvi-api.s3.amazonaws.com/TripValet_Terms_and_Conditions_signup.pdf" target="_blank">terms and conditions</a>
                                            </label>
                                        </div>
                                        <Button
                                            variant="default"
                                            type="button"
                                            className="btn_light"
                                            onClick={handelSubmit}
                                        >Submit</Button>
                                    </div>


                                </Form>
                            </div>

                        </div>
                    </div>
                </div>



            </LoadingOverlay>
        </div>
    )
}
export default VipSignup;